/* eslint-disable require-jsdoc */
import React, {useCallback, useEffect} from 'react';
import Login from './Login';
import TokenManager from './TokenManager';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Logout Page.
  */
function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    signout();
  }, []);

  const syncLogout = useCallback((event) => {
    if (event.key === 'logout') navigate('/');
  }, []);

  useEffect(() => {
    window.addEventListener('storage', syncLogout);
    return () => {
      window.removeEventListener('storage', syncLogout);
    };
  }, [syncLogout]);

  const signout = () => {
    if (TokenManager.getToken()) {
      axios.get(` https://blooming-springs-86289.herokuapp.com/api/login/logout`, {
        withCredentials: true,
      })
          .finally(() => {
            TokenManager.setToken(null);
            window.localStorage.clear();
            window.localStorage.setItem('logout', Date.now());
          });
    }
  };
  return (
    <Login />
  );
}

export default Logout;
